/* eslint-disable @typescript-eslint/naming-convention */
import { css } from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
import { Fields, Group, Label, SelectedOptionWrapper, Submit, SubLabel, Notices } from '@bookingForm/styles/form';
import { Wrapper as CalendarStepWrapper } from '@genericBookings/components/CalendarFormStep/styled';
import { Actions as AttendeeActions, Element as AttendeeElement } from '@genericBookings/components/AttendeesSelector/styles';
import { Wrapper as ProgressWrapper } from '@genericBookings/components/ProgressBar/styles';
import SwwCalendar from '@widgets/shared/components/icons/sww/Calendar';
import SwwCalendarCheck from '@widgets/shared/components/icons/sww/CalendarCheck';
import SwwGroup from '@widgets/shared/components/icons/sww/Group';
import SwwPeople from '@widgets/shared/components/icons/sww/People';
import SwwTime from '@widgets/shared/components/icons/sww/Time';
const headingFont = 'var(--heading-font)';
const font = 'var(--body-font)';
const accent = 'var(--primary-darker)';
const text = 'var(--text)';
const swwTheme = {
    stepIconColour: '#000',
    // Default per-step icons + copy. Copy can be overridden from the form via
    // data-step-config (label / completedLabel / sublabel only; icons stay here).
    stepConfig: {
        date: {
            icon: SwwCalendar,
            selectedOptionIcon: SwwCalendarCheck,
            label: 'Select Your Date',
            completedLabel: 'Date Selected',
            sublabel: 'Pick a festive day for your visit.',
        },
        visitors: {
            icon: SwwGroup,
            selectedOptionIcon: SwwPeople,
            label: 'Your Party',
            completedLabel: undefined,
            sublabel: 'How many are joining the adventure?',
        },
        session: {
            icon: SwwTime,
            selectedOptionIcon: SwwTime,
            label: 'Choose Your Time',
            completedLabel: undefined,
            sublabel: 'Pick a slot that fits your schedule. Sessions are 1:30 hours long ' +
                'but we recommend allowing up to 2 hours for the full experience.',
        },
    },
    includeYear: true,
    selectedDateFormat: 'iiii do MMMM yyyy',
    monthContainer: css `
    width: 100% !important;
    max-width: 42rem !important;
    min-width: 26rem !important;
    border-radius: var(--border-radius-md);
    border: 0;
    overflow: hidden;
  `,
    calendarHeaderButtons: css `
    --primary-medium: #000;
  `,
    // .react-datepicker__header
    calendarHeader: css `
    background-color: transparent;
    padding: 1rem 0;
    justify-content: space-between;
    & > div {
      justify-content: space-between;
    }
  `,
    // wrapper for dates e.g. 1-30.
    calendarDayWrapper: css `
    padding: 0.8rem 0;
  `,
    // date at the top of the calendar e.g. December
    calendarHeading: css `
    font-size: 2.4rem;
    font-weight: 500;
    font-family: var(--heading-font);
    flex-basis: initial;
    color: #000;
    user-select: none;
  `,
    // the calendar wrapper
    defaults: css `
    font: var(--paragraph-font);
    color: var(--text);
    width: 100%;
    max-width: 100%;
    justify-content: center;
    gap: 2rem;
    overflow-x: visible;
    box-shadow: none;

    // vertical gaps between the rows of date cells
    .react-datepicker__week {
      margin-bottom: 0;
    }

    .react-datepicker__week:last-of-type {
      margin-bottom: 0;
    }
  `,
    formWrapper: css `
    width: 100%;
    max-width: 86rem;
    margin: 0 auto;
    overflow: visible;
    padding: 0;

    // set the padding bottom for the arrow bottom
    // @media screen and (max-width: ${MediaSizes.SM_MAX}px) {
    //   &.step--calendar {
    //     padding-bottom: 15rem;
    //   }

    //   &:not(:has(.dates--1)) {
    //     .react-datepicker {
    //       justify-content: flex-start !important; // I don't like this but I can't get more specific
    //     }
    //   }

    //   &:has(.dates--1) {
    //     padding-bottom: 6rem;

    //     .react-datepicker {
    //       justify-content: center;
    //     }
    //   }
    // }
  `,
    availabilityKey: css `
    --border: #e7e6eb;
    position: static;
    transform: none;
    margin-top: 1.2rem;
    justify-content: flex-start;
  `,
    swwArrowWrapper: css `
    display: none;
  `,
    calendarKeyWrapper: css `
    border-radius: 1.6rem;
    border: 0.1rem solid var(--light-grey, #e7e6eb);
    background: #fff;
    padding: 0 1.8rem 2.4rem;
  `,
    calendarWrapper: css `
    transition: 200ms ease-out transform;
    box-shadow: none !important;

    &.highlighted {
      .react-datepicker__month-container {
        outline: 0.4rem solid var(--primary-medium);
      }
    }

    @media screen and (max-width: ${MediaSizes.SM_MAX}px) {
      overflow-x: visible;
      //touch-action: none;
      width: calc(100% + 4rem);
      max-width: initial;
      touch-action: pan-y;
      // normalising based on wrapper padding.
      padding: 0 2rem;
      margin: 0 -2rem;
      justify-content: flex-start;
      border-radius: 0;
    }
  `,
    sessionsWrapper: css `
    background-color: var(--primary-dark);
  `,
    sessionsWrapperAfter: css `
    content: '';
    display: block;
    height: 100%;
    width: 8rem;
    position: absolute;
    right: -2rem;
    top: 0;
    z-index: 10;
    background: linear-gradient(90deg, rgba(0, 87, 170, 0) 0%, rgb(0, 87, 170) 65%); // primary medium
  `,
    formLabel: css `
    font: var(--heading-four-font);
    font-weight: 500;
    color: #000;
    margin-bottom: 2rem;
    flex-wrap: wrap;

    svg {
      // top: -0.3rem;
      // position: relative;
    }

    &.step--complete {
      color: var(--text);
      font-family: var(--body-font);
      font-size: var(--paragraph-medium-font-size);
      font-style: var(--paragraph-medium-font-style);
      font-weight: var(--paragraph-medium-font-weight);
      line-height: normal;
      margin-bottom: 0.8rem;

      ${SubLabel},
      svg {
        display: none;
      }
    }
  `,
    formSubLabel: css `
    margin-top: 0.6rem;
    display: block;
    flex-basis: 100%;
    width: 100%;
    margin-left: 0;
    color: var(--text);
    font-family: var(--body-font);
    font-size: var(--paragraph-medium-font-size);
    font-style: var(--paragraph-medium-font-style);
    font-weight: var(--paragraph-medium-font-weight);
    line-height: normal;
  `,
    selectedOptionWrapper: css `
    border: 0.1rem solid var(--border);
    border-radius: var(--border-radius-sm);
    padding: 1.5rem;
    background-color: white;
    justify-content: flex-start;
  `,
    selectedOptionValue: css `
    font-size: 1.2rem;
    font-weight: 400;
    &,
    span {
      font: var(--paragraph-font);
      font-weight: 500;
    }
  `,
    selectedOptionDummyLink: css `
    text-decoration: none;
    flex: 1 1 auto;
    > span {
      display: none;
    }
  `,
    calendarDay: css `
    user-select: none;

    // remove circle hover effect
    &:hover {
      &::before {
        background-color: transparent;
      }
    }
  `,
    // the availability dot at the top of each date cell
    calendarDayDot: css `
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    margin-bottom: 0.4rem;
    background-color: var(--no-availability);
  `,
    // the boxed date cell (applied to .react-datepicker__day)
    calendarDayBox: css `
    height: auto;
    min-height: 5.6rem;
    padding: 0.7rem 0.2rem;
    background-color: #fff;
    border: 0.1rem solid var(--text);
    border-radius: var(--border-radius-xs, 0.4rem);

    &.react-datepicker__day--selected {
      border-width: 0.2rem;
    }

    &.react-datepicker__day--disabled,
    &.react-datepicker__day--outside-month {
      background-color: #e7e6eb;
      border-color: transparent;
      opacity: 1;

      // keep the grey background on hover (shared dayDisabled sets it transparent)
      &:hover {
        background-color: #e7e6eb;
      }

      // no availability dot on disabled / out-of-range days
      .calendar-day__dot {
        display: none !important;
      }

      // keep the "–" placeholder visible on unavailable dates
      .calendar-day__price {
        opacity: 1 !important;
      }
    }

    // sold-out: shown but not selectable — white bg (not grey), grey dot, dash
    &.sold-out.react-datepicker__day--disabled {
      background-color: #fff;
      border-color: var(--text);

      &:hover {
        background-color: #fff;
      }

      .calendar-day__dot {
        display: block !important;
        background-color: var(--no-availability);
      }

      .calendar-day__price {
        opacity: 1 !important;
      }
    }
  `,
    calendarDayNumber: css `
    font-family: var(--body-font);
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 1;
    color: var(--text);
  `,
    // day-of-week labels (S M T W T F S)
    calendarDOW: css `
    font-family: var(--body-font);
    font-weight: 400;
    font-size: 1.2rem;
    color: #6b7280;
    text-transform: uppercase;
  `,
    calendarDayPrice: css `
    font: var(--paragraph-small-font);
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 1.4rem;
    letter-spacing: 0;
    color: var(--text);
    margin: 0.4rem 0 0;
    position: relative;
    right: 0.2rem;

    .react-datepicker__day--disabled &:not(.holiday-overlay) {
      color: #a6a6a6;
    }
  `,
    calendarDayNumberDisabled: css `
    color: #a6a6a6 !important;
  `,
    sessionCheckbox: css `
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: space-between;
    padding: 1.2rem 1.6rem;
    gap: 1.6rem;
    input:focus-visible + & {
      outline: 0.2rem solid var(--section-bg);
      outline-offset: 0.2rem;
    }
  `,
    sessionCheckboxBefore: css `
    --primary-darker: var(--section-bg);
    border-color: var(--primary-darker);
    background-color: var(--primary-darker);
    box-shadow: var(--primary-darker) 0 0 0 0.4rem inset;
  `,
    sessionTime: css `
    font-family: ${font};
    font-size: 1.6rem;
    font-weight: 800;
    color: ${accent};

    input:checked + label & {
      color: white;
    }
  `,
    sessionPrice: css `
    font-family: ${font};
    font-weight: normal;
    font-size: 1.2rem;
    line-height: normal;
    color: ${text};
    text-transform: none;

    input:checked + label & {
      color: white;
    }
  `,
    sessionAvailability: css `
    input:checked + label & {
      color: white;
    }
  `,
    visitorInfoBand: css `
    border-color: #e7e6eb;
    border-radius: 1.6rem;
    padding: 1.6rem;
    p {
      font-size: 1.2rem;
    }
  `,
    visitorInfoBandPrice: css `
    font-family: ${font};
    font-size: 1.2rem;
    font-weight: 400;
    line-height: normal;
    color: ${text};
    text-transform: uppercase;
  `,
    attendeeBands: css `
    background-color: white;
    padding: 0;
    > li {
      padding: 1.6rem;
      border: 0.1rem solid var(--border);
      border-radius: var(--border-radius-sm);
    }
    > li > div[class] {
      font-size: 1.6rem;
      font-weight: 400;
    }
    > li > div > span[class] {
      font-size: 1.2rem;
      font-weight: 400;
    }
  `,
    attendeeTitle: css `
    font-size: 1.6rem;
    font-weight: 400;
    color: #000;
    &input {
      font-weight: 800;
    }
  `,
    attendeesButton: css `
    border: 0.1rem solid #000 !important;
    &:not(:disabled):hover,
    &:not(:disabled):focus {
      opacity: 0.7;
      border-color: #000;
    }

    &:disabled {
      opacity: 0.2;
    }

    svg {
      fill: #000 !important;
      cursor: inherit;
      height: 1rem;
      width: 1rem;
    }
  `,
    // Attendees step visual order (SWW only): progress → visitors/info → selected date → CTA.
    // display: contents flattens wrappers so flex order can interleave siblings across groups.
    // Note: this only changes paint order, not DOM / keyboard focus order.
    formStepAttendees: css `
    ${Fields} {
      flex-direction: column;
    }

    ${CalendarStepWrapper},
    ${CalendarStepWrapper} > ${Group},
    ${Fields} > ${Group},
    ${AttendeeElement} {
      display: contents;
    }

    ${ProgressWrapper} {
      order: 1;
      width: 100%;
    }

    ${Fields} > ${Group} > ${Label},
    ${AttendeeElement} > * {
      order: 2;
      width: 100%;
    }

    ${CalendarStepWrapper} ${SelectedOptionWrapper} {
      order: 3;
      width: 100%;
      margin-top: 2rem;
    }

    ${AttendeeElement} > ${AttendeeActions} {
      order: 4;
      width: 100%;
      margin-top: 2rem;
    }
  `,
    // Sessions step visual order (SWW only):
    // progress → current session → selected date → selected visitors → basket.
    formStepSessions: css `
    ${ProgressWrapper} {
      order: 1;
      width: 100%;
    }

    ${Fields} > ${Group} {
      order: 4;
      width: 100%;
    }

    ${Fields} > ${Group}:last-of-type {
      order: 2;
    }

    ${CalendarStepWrapper} {
      order: 3;
      width: 100%;
    }

    ${Submit} {
      order: 99;
      width: 100%;
      margin-top: 0;
    }

    ${Notices} {
      order: 5;
      position: relative;
      bottom: 0;
      padding: 0;
      margin-bottom: 3rem;
    }
  `,
    submitWrapper: css `
    background-color: var(--sww-overview-bg);
    color: #000;
    padding: 1.6rem;
    width: 100%;
    max-width: 40rem;
    border-radius: var(--border-radius-sm);
    margin: 3rem auto 0;
  `,
    overviewPriceWrapper: css `
    display: block;
  `,
    overviewPriceLarge: css `
    font: var(--heading-two-font);
    font-size: 3.2rem;
    line-height: 1;
    color: #000;
    text-align: center;
  `,
    overviewPriceSmall: css `
    font-size: 2rem;
    line-height: 2rem;
    color: #000;
    letter-spacing: -0.047rem;
    opacity: 0.5;
    font-family: ${font};
    text-decoration: line-through;
  `,
    // text beneath final price
    overviewSelection: css `
    font: var(--paragraph-font);
    text-align: center;
    a {
      color: var(--primary-medium);

      &:hover {
        text-decoration: underline;
      }
    }
  `,
    quickPayWrapper: css `
    background-color: #fff;
    border-radius: 1rem;
    padding: 1.5rem 3rem;
    margin-top: 1.5rem;
    width: 100%;
  `,
    quickPayTitle: css `
    font-family: var(--heading-font);
    font-size: 1.8rem;
    font-weight: 400;
    letter-spacing: -0.04em;
    display: block;
    margin: 0 auto 1rem;
    text-align: center;
    color: #000;
    line-height: 1;
  `,
    voucherStrapLine: css `
    color: #000;
    text-align: center;
    justify-content: center;
    svg {
      display: none;
    }
  `,
    voucherStrapLineIcon: css `
    fill: #000;
  `,
};
export default swwTheme;
